import { getBaseApiUrl } from '../../../config/api';

const getAuthHeaders = () => {
  const token =
    localStorage.getItem('pathbuddy_access_token') ||
    sessionStorage.getItem('pathbuddy_access_token') ||
    localStorage.getItem('token');
  const isPasscodeAuth = sessionStorage.getItem('ivori_certadmin_auth') === 'true';
  const storedPasscode =
    sessionStorage.getItem('ivori_admin_passcode') ||
    sessionStorage.getItem('ivori_certadmin_passcode') ||
    '';
  const headers = {
    'Content-Type': 'application/json'
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  // Audit #17: never hardcode the passcode — only send what the user verified.
  if (isPasscodeAuth && storedPasscode) {
    headers['X-Admin-Passcode'] = storedPasscode;
  }
  return headers;
};

export const eventAPI = {
  /**
   * Unlock an event gallery using an attendee access code.
   */
  async verifyAccessCode(accessCode) {
    if (!accessCode) {
      throw new Error('Access code is required');
    }

    const response = await fetch(`${getBaseApiUrl()}/api/events/verify-code`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ access_code: accessCode.trim().toUpperCase() })
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      throw new Error(data.error || 'Invalid or expired event access code');
    }

    return data.event;
  },

  /**
   * Get public preview for an event by slug.
   */
  async getEventPreview(slug) {
    const response = await fetch(`${getBaseApiUrl()}/api/events/${encodeURIComponent(slug)}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Event not found');
    }

    return data.event;
  },

  /**
   * List all public events.
   */
  async listEvents() {
    const response = await fetch(`${getBaseApiUrl()}/api/events/`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });

    const data = await response.json();
    if (!response.ok) {
      return [];
    }

    return data.events || [];
  },

  /**
   * Admin: Create a new event media album.
   */
  async createEvent(eventData) {
    const response = await fetch(`${getBaseApiUrl()}/api/events/`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(eventData)
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Failed to create event');
    }

    return data.event;
  },

  /**
   * Admin: Add media items to an event.
   */
  async addMediaToEvent(eventId, mediaList) {
    const response = await fetch(`${getBaseApiUrl()}/api/events/${eventId}/media`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ media: mediaList })
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Failed to upload media items');
    }

    return data;
  }
};
